/**
 * @file Purchase PPD Print Package Item.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import classNames from 'classnames';

import { PPD_CART_ITEM_TYPES } from '../../constants/ppd-purchase';
import Alert from '../global/Alert';
import { formatPriceForDisplay } from '../../util/format-money';
import { isCartItemSelected } from '../../util/ppd-purchase';
import CustomControl from '../global/CustomControl';
import { DIGITAL_DOWNLOADS_MODE } from '../../constants/print-packages';
import {
  getPrintPackageItemLabel,
  sortPrintPackageItems,
} from '../../util/print-packages';

class PurchasePpdPrintPackageItem extends Component {
  static propTypes = {
    photo: PropTypes.shape({
      id: PropTypes.string,
      thumbnail_urls: PropTypes.arrayOf(
        PropTypes.shape({
          width: PropTypes.number,
          height: PropTypes.number,
          url: PropTypes.string,
        }),
      ),
    }),
    albumPrintPackage: PropTypes.shape({
      total: PropTypes.number,
      record: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          print_package: PropTypes.shape({
            id: PropTypes.string,
            items: PropTypes.shape({
              records: PropTypes.arrayOf(
                PropTypes.shape({
                  id: PropTypes.string.isRequired,
                  quantity: PropTypes.number,
                  type: PropTypes.shape({
                    name: PropTypes.string,
                    min_price: PropTypes.shape({
                      value: PropTypes.number,
                    }),
                  }),
                }),
              ),
            }),
            digital_downloads_mode: PropTypes.oneOf(
              Object.values(DIGITAL_DOWNLOADS_MODE),
            ),
            digital_downloads_upsell_price: PropTypes.shape({
              value: PropTypes.number,
            }),
          }),
        }),
      ),
    }),
    cart: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf(Object.keys(PPD_CART_ITEM_TYPES)),
        photo: PropTypes.shape({
          id: PropTypes.string,
        }),
        printSize: PropTypes.shape({
          id: PropTypes.string,
        }),
        printPackage: PropTypes.shape({
          id: PropTypes.string,
        }),
        quantity: PropTypes.number,
      }),
    ),
    toggleCartItem: PropTypes.func.isRequired,
    removeDownloadItem: PropTypes.bool,
  };

  render() {
    const {
      cart,
      photo,
      toggleCartItem,
      albumPrintPackage,
      removeDownloadItem,
    } = this.props;

    const printPackage = get(albumPrintPackage, 'print_package');
    const items = sortPrintPackageItems(
      get(printPackage, 'items.records', []),
    ).filter(item => item.quantity > 0);

    const isSelected = isCartItemSelected(
      cart,
      photo.id,
      PPD_CART_ITEM_TYPES.PRINT_PACKAGE,
      albumPrintPackage,
    );

    const isDownloadSelected = isCartItemSelected(
      cart,
      photo.id,
      PPD_CART_ITEM_TYPES.DOWNLOAD,
    );

    const classes = classNames({
      'ppd-print-package': true,
      selected: isSelected,
    });

    return (
      <div key={printPackage.id} className="col-12">
        <a
          href="#"
          className={classes}
          onClick={event => {
            event.preventDefault();
            // Remove download from cart if needed.
            if (isDownloadSelected && removeDownloadItem) {
              toggleCartItem(photo.id, PPD_CART_ITEM_TYPES.DOWNLOAD);
            }

            toggleCartItem(
              photo.id,
              PPD_CART_ITEM_TYPES.PRINT_PACKAGE,
              albumPrintPackage,
              1,
            );
          }}
        >
          <Alert type="info" className="h-100 mb-0">
            <CustomControl
              type="checkbox"
              id={printPackage.id}
              readOnly
              labelSrOnly
              checked={isSelected}
              showHint
            />
            <p className="text-primary mb-1 text-md text-bold">
              {printPackage.name}
            </p>
            <p className="text-dark text-bold">
              $
              {formatPriceForDisplay(get(printPackage, 'price.value', 0), true)}
            </p>
            <div className="d-block text-dark text-xs">
              <span className="d-block text-normal">
                {items
                  .map(
                    item =>
                      `${item.quantity} × ${getPrintPackageItemLabel(item)}`,
                  )
                  .join(', ')}
              </span>
              {printPackage.digital_downloads_mode ===
                DIGITAL_DOWNLOADS_MODE.UPSELL && (
                <span className="d-block">
                  Add Hi-Res download for $
                  {formatPriceForDisplay(
                    get(
                      printPackage,
                      'digital_downloads_upsell_price.value',
                      0,
                    ),
                    true,
                  )}
                </span>
              )}
              {printPackage.digital_downloads_mode ===
                DIGITAL_DOWNLOADS_MODE.INCLUDED && (
                <span className="d-block text-bold">
                  Includes Hi-Res Download for this photo
                </span>
              )}
            </div>
          </Alert>
        </a>
      </div>
    );
  }
}

export default PurchasePpdPrintPackageItem;
